import { useState } from "react"


function Contact() {
    const[state,setState]=useState({
        name:"", email:"",subject:"",Message:""
        })
        const handler=(e)=>{
  //console.log(e.target.name)
  setState({...state,[e.target.name]:e.target.value})
}
const handleSubmit=()=>{
    console.log(state)
}

  return (
   <>
     {/* <!-- Page Header Start --> */}
    <div className="container-fluid bg-primary py-5 mb-5">
        <div className="container py-5">
            <div className="row align-items-center py-4">
                <div className="col-md-6 text-center text-md-left">
                    <h1 className="display-4 mb-4 mb-md-0 text-secondary text-uppercase">Contact</h1>
                </div>
                <div className="col-md-6 text-center text-md-right">
                    <div className="d-inline-flex align-items-center">
                        <a className="btn btn-sm btn-outline-light" href="">Home</a>
                        <i className="fas fa-angle-double-right text-light mx-2"></i>
                        <a className="btn btn-sm btn-outline-light disabled" href="">Contact</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Page Header End -->


    <!-- Contact Start --> */}
    <div className="container-fluid py-5">
        <div className="container">
            <div className="row align-items-end mb-4">
                <div className="col-lg-6">
                    <h6 className="text-secondary font-weight-semi-bold text-uppercase mb-3">Contact Us</h6>
                    <h1 className="section-title mb-3">Contact Us For Cleaning Services</h1>
                </div>
                <div className="col-lg-6">
                    <h4 className="font-weight-normal text-muted mb-3">Eirmod kasd duo eos et magna, diam dolore stet sea clita sit ea erat lorem. Ipsum eos ipsum magna lorem stet</h4>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-7 mb-5 mb-lg-0">
                    <div className="contact-form">
                        <div id="success"></div>
                        <form name="sentMessage" id="contactForm" noValidate="noValidate">
                            <div className="form-row">
                                <div className="col-sm-6 control-group">
                                    <input type="text" 
                                    name='name'
                                    value={state.name} 
                                    onChange={handler}
                                    className="form-control p-4" id="name" placeholder="Your Name" required="required" data-validation-required-message="Please enter your name" />
                                    <p className="help-block text-danger"></p>
                                </div>
                                <div className="col-sm-6 control-group">
                                    <input type="email" 
                                     name='email'
                                     value={state.email} 
                                     onChange={handler}
                                    className="form-control p-4" id="email" placeholder="Your Email" required="required" data-validation-required-message="Please enter your email" />
                                    <p className="help-block text-danger"></p>
                                </div>
                            </div>
                            <div className="control-group">
                                <input type="text"
                                 name='subject'
                                 value={state.subject} 
                                 onChange={handler}
                                 className="form-control p-4" id="subject" placeholder="Subject" required="required" data-validation-required-message="Please enter a subject" />
                                <p className="help-block text-danger"></p>
                            </div>
                            <div className="control-group">
                                <textarea
                                   name='msg'
                                   value={state.msg} 
                                   onChange={handler}
                                 className="form-control p-4" rows="6" id="message" placeholder="Message" required="required" data-validation-required-message="Please enter your message"></textarea>
                                <p className="help-block text-danger"></p>
                            </div>
                            <div>
                                <button 
                                onClick={handleSubmit} className="btn btn-primary btn-block py-3 px-5" type="button" id="sendMessageButton">Send Message</button>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="col-lg-5" style={{minHeight: "400px"}}>
                    <div className="position-relative h-100 rounded overflow-hidden">
                        <iframe style={{width: "100%", height: "100%", objectFit: "cover"}}
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
                        frameborder="0"  allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Contact End --> */}

   </>
  )
}

export default Contact